import { Stack, StackProps } from '@chakra-ui/react'
import { themeColors } from 'theme'

interface CardBodyProps extends StackProps {
  p?: number
  isFullScreen?: boolean
  isFullWidth?: boolean
  isBorder?: boolean
  isPage?: boolean
  isSelected?: boolean | null
}

export const CardBody: React.FC<CardBodyProps> = ({
  children, p, isBorder = false, isFullWidth = false, isFullScreen = false, isSelected = false, ...props
}) => {
  const {
    card: { bgBorderColor, bgColor, bgColorSecondary } } = themeColors

  return (
    <Stack
      mx="auto"
      w={'100%'}
      {...!isFullWidth && { maxW: { base: 'full', md: 460 } }}
      h={isFullScreen ? 'full' : 'fit-content'}
      rounded='2xl'
      borderColor={isSelected ? bgColorSecondary : bgBorderColor}
      borderWidth={isBorder ? 3 : { base: 0, md: 3 }}
      p={isBorder ? 4 : { base: p ?? 0, md: p ?? 4 }}
      bg={bgColor}
      justifyContent='center'
      alignContent='center'
      alignItems='center'
      spacing={4}
      {...props}>
      {children}
    </Stack>
  )
}
